import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { AgreementsService } from 'src/app/pages/agreements/services/agreements.service';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'app-credit-card-confirmation',
  templateUrl: './credit-card-confirmation.component.html',
  styleUrls: ['./credit-card-confirmation.component.scss'],
})
export class CreditCardConfirmationComponent implements OnInit {
  @Input() hasAgreement: boolean;

  pendingAgreements = [];

  constructor(
    public modalCtrl: ModalController,
    private navCtrl: NavController,
    protected alertCtrl: AlertController,
    private utilityService: UtilityService,
    private agreementsService: AgreementsService,
  ) {}

  ngOnInit() {
    this.getPendingAgreements();
  }

  /**
   * Redirect to agreement or search workers page.
   *
   */
  redirect() {
    this.modalCtrl.dismiss();

    if (this.hasAgreement) {
      const route: string =
        this.pendingAgreements.length === 1 ? `/agreement/view/${this.pendingAgreements[0]?.id}` : '/tabs/agreements';
      this.navCtrl.navigateForward(route);
    } else {
      this.navCtrl.navigateForward('/search/triage');
    }
  }

  /**
   * Get pending agreeements of workers
   */
  async getPendingAgreements() {
    const requestLoader = await this.utilityService.showLoading();
    try {
      const res = await this.agreementsService.getAgreementList('myWorkers');
      if (res['myWorkers']) {
        this.pendingAgreements = res['myWorkers'].nodes.filter((agreement) => agreement.status === 'initiated');
      }
    } catch (e) {
      await this.utilityService.showErrorAlert('Unable to retrieve agreement information');
    } finally {
      this.utilityService.hideLoading(requestLoader);
    }
  }
}
